/** Birchwood logo letter colors (B-I-R-C-H-W-O-O-D) */
export const CLASSROOM_COLORS = [
  { value: "PURPLE", label: "Purple", tone: "is-purple", hex: "#9B59B6" },
  { value: "PINK", label: "Pink", tone: "is-pink", hex: "#E91E8C" },
  { value: "BLUE", label: "Blue", tone: "is-blue", hex: "#2E6BE6" },
  { value: "GREEN", label: "Green", tone: "is-green", hex: "#8BC34A" },
  { value: "ORANGE", label: "Orange", tone: "is-orange", hex: "#FF6F00" },
  { value: "CORAL", label: "Coral", tone: "is-coral", hex: "#FF6B5B" },
  { value: "YELLOW", label: "Yellow", tone: "is-yellow", hex: "#FFD500" },
  { value: "ROSE", label: "Rose", tone: "is-rose", hex: "#FF4081" },
];

export const DEFAULT_CLASSROOM_COLOR = "BLUE";

export function classroomColorMeta(color) {
  return (
    CLASSROOM_COLORS.find((item) => item.value === color) ||
    CLASSROOM_COLORS.find((item) => item.value === DEFAULT_CLASSROOM_COLOR)
  );
}

export function classroomColorTone(color) {
  return classroomColorMeta(color).tone;
}

export function classroomColorLabel(color) {
  return classroomColorMeta(color).label;
}

export const LOGO_COLOR_VALUES = CLASSROOM_COLORS.map((item) => item.value);

export function isLogoColor(value) {
  return LOGO_COLOR_VALUES.includes(value);
}
